import type { Dispatch, SetStateAction } from "react";
import { useState } from "react";

import { Icon } from "@/components/common/Icon";
import { Field } from "@/components/onboarding/OnbFields";
import { Avatar, Button } from "@/components/common";

import type { WsForm } from "./types";

interface Props {
  form: WsForm;
  setForm: Dispatch<SetStateAction<WsForm>>;
}

const papelLabel = (p: string) =>
  p === "admin" ? "Admin" : p === "senior" ? "Sênior" : "Analista";

export function WsStepEquipe({ form, setForm }: Props) {
  const [draft, setDraft] = useState({
    nome: "",
    email: "",
    papel: "analista",
  });

  const addConvite = () => {
    if (!draft.email) return;
    setForm((f) => ({ ...f, convites: [...f.convites, { ...draft }] }));
    setDraft({ nome: "", email: "", papel: "analista" });
  };
  const remove = (i: number) => {
    setForm((f) => ({
      ...f,
      convites: f.convites.filter((_, idx) => idx !== i),
    }));
  };

  return (
    <>
      <div className="onb-section-head">
        <div className="onb-step-eyebrow">ETAPA 3 · OPCIONAL</div>
        <h1 className="onb-step-title">Convide sua equipe</h1>
        <p className="onb-step-sub">
          Adicione outros usuários que vão operar o workspace junto com você.
          Você pode convidar mais pessoas depois pela tela de Equipe.
        </p>
      </div>

      <div className="onb-section">
        <div className="onb-section-title">Novo convite</div>
        <div className="onb-field-grid onb-grid-3">
          <Field label="Nome">
            <input
              className="onb-input"
              value={draft.nome}
              onChange={(e) => setDraft({ ...draft, nome: e.target.value })}
              placeholder="Nome completo"
            />
          </Field>
          <Field label="E-mail">
            <input
              className="onb-input"
              type="email"
              value={draft.email}
              onChange={(e) => setDraft({ ...draft, email: e.target.value })}
              placeholder="email@empresa.com.br"
            />
          </Field>
          <Field label="Papel">
            <select
              className="onb-input"
              value={draft.papel}
              onChange={(e) => setDraft({ ...draft, papel: e.target.value })}
            >
              <option value="admin">Admin</option>
              <option value="senior">Sênior</option>
              <option value="analista">Analista</option>
            </select>
          </Field>
        </div>
        <Button
          variant="ghost"
          iconLeft="plus"
          onClick={addConvite}
          disabled={!draft.email}
        >
          Adicionar à lista
        </Button>
      </div>

      {form.convites.length > 0 && (
        <div className="onb-section">
          <div className="onb-section-title">
            {form.convites.length} pessoa{form.convites.length > 1 ? "s" : ""}{" "}
            na fila de convites
          </div>
          <div className="onb-invite-list">
            {form.convites.map((c, i) => (
              <div key={i} className="onb-invite-row">
                <Avatar size="sm" name={c.nome || c.email} />
                <div className="onb-invite-row-body">
                  <div className="onb-invite-row-name">
                    {c.nome || c.email}
                  </div>
                  <div className="onb-invite-row-email">{c.email}</div>
                </div>
                <span className="tag-chip onb-invite-row-tag">
                  {papelLabel(c.papel)}
                </span>
                <button
                  className="row-act"
                  onClick={() => remove(i)}
                  aria-label="Remover"
                >
                  <Icon name="x" size={14} />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
